import React from 'react'

const BoxChildAge = ({
    index,
    label,
    age,
    min,
    max,
    onChange
}) => {
    const updateAgeHandler = (e) => {
        const value = e.target.value

        onChange(value)
    }

    return (
        <div className="child-age-box">
            <label className="child-age-box__label">{label}<sup>*</sup></label>
            <input
                type="number"
                required
                min={min}
                max={max}
                placeholder='-'
                value={age}
                onChange={(e) => updateAgeHandler(e)}
                className="child-age-box__input"
            />
        </div>
    )
}

export default BoxChildAge;
